export const Preloader = () => (
  <div className="preloader-wrapper">
    <div className="spinner">
      <div className="circle"></div>
    </div>
  </div>
);
